import {
    Component,
    Input,
    inject,
    OnInit,
    signal,
    ChangeDetectionStrategy,
    DestroyRef,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { AuthStateService } from '@baboor/baboor-auth'
import { SpanishDirective } from '@baboor/baboor-language'
import { AppDetailsService } from '@baboor/common-services'
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco'
import { AccordionModule } from '@openng/optimus-ui/accordion'
import { TooltipModule } from '@openng/optimus-ui/tooltip'
import { NavigationGroup } from './vendor-sidebar-model'
import { navigationGroups } from './vendor-sidebar.data'

@Component({
    selector: 'app-sidebar-vendor',
    imports: [
        RouterLink,
        RouterLinkActive,
        TranslocoModule,
        SpanishDirective,
        AccordionModule,
        TooltipModule,
    ],
    templateUrl: './sidebar-vendor.component.html',
    styleUrl: './sidebar-vendor.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [provideTranslocoScope('vendorDashboard')],
})
export class SidebarVendorComponent implements OnInit {
    authStateService = inject(AuthStateService)
    private appDetailsService = inject(AppDetailsService)
    private destroyRef = inject(DestroyRef)
    @Input() isCollapsed = false
    version = signal<string>('')
    navigationGroups: NavigationGroup[] = navigationGroups
    filteredNavigationGroups: NavigationGroup[] = []

    constructor() {
        this.filteredNavigationGroups = this.filterGroups(navigationGroups)
    }

    async ngOnInit() {
        this.filteredNavigationGroups = this.filterGroups(navigationGroups)

        this.authStateService
            .select('userDetails')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.filteredNavigationGroups =
                    this.filterGroups(navigationGroups)
            })

        const appVersion = await (
            await this.appDetailsService.getAppDetails()
        ).version
        this.version.set(appVersion)
    }

    private filterGroups(groups: NavigationGroup[]): NavigationGroup[] {
        return groups
            .map((group) => ({
                ...group,
                items: group.items.filter(
                    (item) =>
                        !item.permission ||
                        this.authStateService.hasPermission(item.permission),
                ),
            }))
            .filter((group) => group.items.length > 0)
    }
}
